import React, { useState } from "react"
import {graphql, useStaticQuery} from "gatsby"

import perfStyles from './model_perf.module.scss'
import DisplayPerfPct from "../helper_js/display_perf_pct"
import DisplayPerfRmse from "../helper_js/display_perf_rmse"
import PerfChart from "../helper_js/perf_chart"
import ReturnChart from "../helper_js/perf_chart_return"


const ModelPerf = () => { 
    const data = useStaticQuery(graphql`
        query {
            allScoredModelsCsv {
                nodes {
                    season
                    week
                    week_id
                    _538_brier_all_time
                    _538_close_ats_all_time
                    _538_close_ats_break_even_all_time
                    _538_close_ats_break_even_return_all_time
                    _538_close_ats_return_all_time
                    _538_open_ats_all_time
                    _538_open_ats_break_even_all_time
                    _538_open_ats_break_even_return_all_time
                    _538_open_ats_return_all_time
                    _538_rmse_all_time
                    _538_su_all_time
                    market_brier_all_time
                    market_open_brier_all_time
                    market_open_rmse_all_time
                    market_open_su_all_time
                    market_rmse_all_time
                    market_su_all_time
                    nfelo_brier_all_time
                    nfelo_close_ats_all_time
                    nfelo_close_ats_be_all_time
                    nfelo_close_ats_be_return_all_time
                    nfelo_close_ats_return_all_time
                    nfelo_open_ats_all_time
                    nfelo_open_ats_be_all_time
                    nfelo_open_ats_be_return_all_time
                    nfelo_open_ats_return_all_time
                    nfelo_rmse_all_time
                    nfelo_su_all_time
                    nfelo_unregressed_brier_all_time
                    nfelo_unregressed_rmse_all_time
                    nfelo_unregressed_su_all_time
                    qbelo_brier_all_time
                    qbelo_close_ats_all_time
                    qbelo_close_ats_break_even_all_time
                    qbelo_close_ats_break_even_return_all_time
                    qbelo_close_ats_return_all_time
                    qbelo_open_ats_all_time
                    qbelo_open_ats_break_even_all_time
                    qbelo_open_ats_break_even_return_all_time
                    qbelo_open_ats_return_all_time
                    qbelo_rmse_all_time
                    qbelo_su_all_time
                }
            }
            allScoredModelsSeasonCsv {
                nodes {
                    season_index
                    season
                    _538_close_ats
                    _538_close_ats_break_even
                    _538_open_ats
                    _538_open_ats_break_even
                    _538_rmse
                    _538_se
                    _538_su
                    market_open_rmse
                    market_open_se
                    market_open_su
                    market_rmse
                    market_se
                    market_su
                    nfelo_close_ats
                    nfelo_close_ats_be
                    nfelo_open_ats
                    nfelo_open_ats_be
                    nfelo_rmse
                    nfelo_se
                    nfelo_su
                    nfelo_unregressed_rmse
                    nfelo_unregressed_se
                    nfelo_unregressed_su
                    qbelo_close_ats
                    qbelo_close_ats_break_even
                    qbelo_open_ats
                    qbelo_open_ats_break_even
                    qbelo_rmse
                    qbelo_se
                    qbelo_su
                }
            }
        }    
    `)

    const chart_tabs = [
        {
            'index' : 0,
            'id' : 'brier',
            'name' : 'Realtive Brier Score',
            'text' : 'Brier score relative to the closing Vegas line. Brier Score is a modified version of RMSE that measures how accurately the model projects the final margin. Higher is better.',
            'component' : <PerfChart
                data={data}
            />,
        }, 
        {
            'index' : 1,
            'id' : 'ats',
            'name' : 'ATS Return',
            'text' : 'ATS Return measures the cumulative return of the model against the spread on break-even or better games with $100 unit sizes.',
            'component' : <ReturnChart
                data={data}
            />,
        }, 
    ]

    const [selectedTab, setSelectedTab] = useState(0);

    const textToDisplay = chart_tabs[selectedTab]['text']
    const tabToDisplay =  chart_tabs[selectedTab]['component']


    function GetSortOrder(prop) {
        return function(a, b)  {
            if (parseInt(a[prop]) < parseInt(b[prop])) {
                return 1;
            } else if (parseInt(a[prop]) > parseInt(b[prop])) {
                return -1;
            } else {
                return 0;
            }
        }
    }

    var yearData = data.allScoredModelsSeasonCsv.nodes.sort(GetSortOrder('season')) 

    const yearDataTabbed = yearData.map((year) => {
        return(
            {
                'index' : year['season_index'],
                'year_data' : year,
                'name' : year['season'],
                'id' : year['season'], 
            }
        )
    })


    const [selectedYear, setSelectedYear] = useState(0);
    const yearDataToDisplay = yearDataTabbed[selectedYear]['year_data']


    const recent_week = data.allScoredModelsCsv.nodes[data.allScoredModelsCsv.nodes.length -1]

    return (
        <div className={perfStyles.cardContainer}>
            <h3 className={perfStyles.cardTitle}>About</h3>
            <div className={perfStyles.aboutDiv}>
                <p className={perfStyles.aboutParagraph}>
                    nfelo is a prediction model built on top of 538's Elo framework that uses unique dynamics about the NFL to improve prediction accuracy. It is one of the (if not the!) most accurate public models available on the internet.
                </p>
                <p className={perfStyles.aboutParagraph}>
                    The tables below show model performance for 538, nfelo, and the Vegas line across a variety of measures. "Straight up" describes a model's ability to pick winners, "RMSE" describes a model's ability to predict the final margin of victory, and "ATS" describes a model's ability to beat the spread.
                </p>
                <p className={perfStyles.aboutParagraph}>
                    Straight up and RMSE take all games into consideration while ATS only considers games rated break-even or better. Break-even for nfelo is defined by expected value, while 538 is defined by games with a delta between projected line and market line of over 1.5.
                </p>
            </div>
            <div className={perfStyles.spacerDiv}></div>
            <h3 className={perfStyles.cardTitle}>All Time (Since 2009)</h3>
            <div className={perfStyles.cardDiv}>
                <div className={perfStyles.perfTableContainer}>
                    <table className={perfStyles.perfTable}>
                        <thead className={perfStyles.perfTableHeaderRow}>
                            <th>

                            </th>
                            <th>
                                538
                            </th>
                            <th>
                                nfelo
                            </th>
                            <th>
                                Vegas (Open)
                            </th>
                            <th>
                                Vegas (Close)
                            </th>
                        </thead>
                        <tbody>
                            <tr className={perfStyles.perfTableRow}>
                                <td>
                                    <div className={perfStyles.metricDiv}>
                                        <p className={perfStyles.metricTitle}>
                                            Straight Up %
                                        </p>
                                        <p className={perfStyles.metricSubTitle}>
                                            % of winners picked correctly
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={recent_week['qbelo_su_all_time']}
                                        market_pct={recent_week['market_su_all_time']}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={recent_week['nfelo_su_all_time']}
                                        market_pct={recent_week['market_su_all_time']}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={recent_week['market_open_su_all_time']}
                                        market_pct={recent_week['market_su_all_time']}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={recent_week['market_su_all_time']}
                                        market_pct={recent_week['market_su_all_time']}
                                        scale={1000}
                                    />
                                </td>
                            </tr>
                            <tr className={perfStyles.perfTableRow}>
                                <td>
                                    <div className={perfStyles.metricDiv}>
                                        <p className={perfStyles.metricTitle}>
                                            RMSE
                                        </p>
                                        <p className={perfStyles.metricSubTitle}>
                                            Error in predicting final margin (lower is better)
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <DisplayPerfRmse 
                                        rmse={recent_week['qbelo_rmse_all_time']}
                                        market_rmse={recent_week['market_rmse_all_time']}
                                        scale={100}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfRmse 
                                        rmse={recent_week['nfelo_rmse_all_time']}
                                        market_rmse={recent_week['market_rmse_all_time']}
                                        scale={100}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfRmse
                                        rmse={recent_week['market_open_rmse_all_time']}
                                        market_rmse={recent_week['market_rmse_all_time']}
                                        scale={100}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfRmse
                                        rmse={recent_week['market_rmse_all_time']}
                                        market_rmse={recent_week['market_rmse_all_time']}
                                        scale={100}
                                    />
                                </td>
                            </tr>
                            <tr className={perfStyles.perfTableRow}>
                                <td>
                                    <div className={perfStyles.metricDiv}>
                                        <p className={perfStyles.metricTitle}>
                                            ATS (Open)
                                        </p>
                                        <p className={perfStyles.metricSubTitle}>
                                            Record against the opening line on break-even or better plays
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={recent_week['qbelo_open_ats_break_even_all_time']}
                                        market_pct={0.524}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={recent_week['nfelo_open_ats_be_all_time']}
                                        market_pct={0.524}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                </td>
                                <td>
                                </td>
                            </tr>
                            <tr className={perfStyles.perfTableRow}>
                                <td>
                                    <div className={perfStyles.metricDiv}>
                                        <p className={perfStyles.metricTitle}>
                                            ATS (Close)
                                        </p>
                                        <p className={perfStyles.metricSubTitle}>
                                            Record against the closing line on break-even or better plays
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={recent_week['qbelo_close_ats_break_even_all_time']}
                                        market_pct={0.524}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={recent_week['nfelo_close_ats_be_all_time']}
                                        market_pct={0.524}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                </td>
                                <td>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={perfStyles.spacerDiv}></div>
            <h3 className={perfStyles.cardTitle}>By Season</h3>
            <div className={perfStyles.tab_container}>
                {yearDataTabbed.map((item) => {
                    return (
                        <button
                            className={perfStyles.tab_button}
                            key={item.id}
                            onClick={()=> setSelectedYear(item.index)}
                            data-active={selectedYear===item.index ? true : false }
                        >
                            {item.name}
                        </button>
                    )
                })}
            </div>
            <div className={perfStyles.cardDiv}>
                <div className={perfStyles.perfTableContainer}>
                    <table className={perfStyles.perfTable}>
                        <thead className={perfStyles.perfTableHeaderRow}>
                            <th>

                            </th>
                            <th>
                                538
                            </th>
                            <th>
                                nfelo
                            </th>
                            <th>
                                Vegas (Open)
                            </th>
                            <th>
                                Vegas (Close)
                            </th>
                        </thead>
                        <tbody>
                            <tr className={perfStyles.perfTableRow}>
                                <td>
                                    <div className={perfStyles.metricDiv}>
                                        <p className={perfStyles.metricTitle}>
                                            Straight Up %
                                        </p>
                                        <p className={perfStyles.metricSubTitle}>
                                            % of winners picked correctly
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={yearDataToDisplay['qbelo_su']}
                                        market_pct={yearDataToDisplay['market_su']}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={yearDataToDisplay['nfelo_su']}
                                        market_pct={yearDataToDisplay['market_su']}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={yearDataToDisplay['market_open_su']}
                                        market_pct={yearDataToDisplay['market_su']}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={yearDataToDisplay['market_su']}
                                        market_pct={yearDataToDisplay['market_su']}
                                        scale={1000}
                                    />
                                </td>
                            </tr>
                            <tr className={perfStyles.perfTableRow}>
                                <td>
                                    <div className={perfStyles.metricDiv}>
                                        <p className={perfStyles.metricTitle}>
                                            RMSE
                                        </p>
                                        <p className={perfStyles.metricSubTitle}>
                                            Error in predicting final margin (lower is better)
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <DisplayPerfRmse 
                                        rmse={yearDataToDisplay['qbelo_rmse']}
                                        market_rmse={yearDataToDisplay['market_rmse']}
                                        scale={100}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfRmse 
                                        rmse={yearDataToDisplay['nfelo_rmse']}
                                        market_rmse={yearDataToDisplay['market_rmse']}
                                        scale={100}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfRmse
                                        rmse={yearDataToDisplay['market_open_rmse']}
                                        market_rmse={yearDataToDisplay['market_rmse']}
                                        scale={100}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfRmse
                                        rmse={yearDataToDisplay['market_rmse']}
                                        market_rmse={yearDataToDisplay['market_rmse']}
                                        scale={100}
                                    />
                                </td>
                            </tr>
                            <tr className={perfStyles.perfTableRow}>
                                <td>
                                    <div className={perfStyles.metricDiv}>
                                        <p className={perfStyles.metricTitle}>
                                            ATS (Open)
                                        </p>
                                        <p className={perfStyles.metricSubTitle}>
                                            Record against the opening line on break-even or better plays
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={yearDataToDisplay['qbelo_open_ats_break_even']}
                                        market_pct={0.524}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={yearDataToDisplay['nfelo_open_ats_be']}
                                        market_pct={0.524}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                </td>
                                <td>
                                </td>
                            </tr>
                            <tr className={perfStyles.perfTableRow}>
                                <td>
                                    <div className={perfStyles.metricDiv}>
                                        <p className={perfStyles.metricTitle}>
                                            ATS (Close)
                                        </p>
                                        <p className={perfStyles.metricSubTitle}>
                                            Record against the closing line on break-even or better plays
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={yearDataToDisplay['qbelo_close_ats_break_even']}
                                        market_pct={0.524}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                    <DisplayPerfPct 
                                        pct={yearDataToDisplay['nfelo_close_ats_be']}
                                        market_pct={0.524}
                                        scale={1000}
                                    />
                                </td>
                                <td>
                                </td>
                                <td>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={perfStyles.spacerDiv}></div>
            <h3 className={perfStyles.cardTitle}>Cumulative Charts</h3>
            <div className={perfStyles.tab_container}>
                {chart_tabs.map((item) => {
                    return (
                        <button
                            className={perfStyles.tab_button}
                            key={item.id}
                            onClick={()=> setSelectedTab(item.index)}
                            data-active={selectedTab===item.index ? true : false }
                        >
                            {item.name}
                        </button>
                    )
                })}
            </div>
            <div className={perfStyles.aboutDiv}>
                <p className={perfStyles.aboutParagraph}>
                    {textToDisplay}
                </p>
            </div>
            <div className={perfStyles.cardDiv}>
                {tabToDisplay}
            </div>
        </div>
    )

}

export default ModelPerf